import { Button as MUIButton, ButtonProps, CircularProgress } from '@mui/material';
import React, { ReactNode } from 'react';

interface ButtonsProps extends ButtonProps {
  children: ReactNode;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  loading?: boolean;
}

export const Button: React.FC<ButtonsProps> = ({
  children,
  onClick,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  disabled = false,
  startIcon,
  endIcon,
  loading = false,
  ...rest
}) => (
  <MUIButton
    onClick={onClick}
    variant={variant}
    color={color}
    size={size}
    disabled={disabled || loading}
    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : startIcon}
    endIcon={endIcon}
    sx={{
      ...(loading ? { opacity: 0.7 } : {}),
    }}
    {...rest}>
    {children}
  </MUIButton>
);

